import { memo } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { Estate, EstateTaskIdentifier, EstateTaskInstance } from 'queries';

import AssignedTaskStatus from 'pages/assigned-tasks-page/components/assigned-task-status';
import AssignedTrusuiteSearchTaskStatus from 'pages/assigned-tasks-page/components/assigned-trusuite-search-task-status';

import UnassignedTaskStatus from '../unassigned-task-status';

interface StatusCellProps extends GridRenderCellParams {
  estate: Estate;
  setCurrentEstateTaskInstance: (instance: EstateTaskInstance) => void;
  setShowAssignedTaskDrawer: (open: boolean) => void;
}

const StatusCell = ({
  row,
  estate,
  setCurrentEstateTaskInstance,
  setShowAssignedTaskDrawer,
}: StatusCellProps) => {
  const estateTaskInstance = row as EstateTaskInstance;

  if (estateTaskInstance.identifier === EstateTaskIdentifier.TrusuiteSearch) {
    return <AssignedTrusuiteSearchTaskStatus estateStatus={estate.status} />;
  } else if (estateTaskInstance.estateWorkItemId) {
    return (
      <AssignedTaskStatus
        estateWorkItemStatus={estateTaskInstance.estateWorkItem!.status}
        estateWorkItemSubStatus={estateTaskInstance.estateWorkItem!.subStatus}
        onClick={() => {
          setCurrentEstateTaskInstance(estateTaskInstance);
          setShowAssignedTaskDrawer(true);
        }}
      />
    );
  }

  return <UnassignedTaskStatus estateTaskInstanceStatus={estateTaskInstance.status} />;
};

const areEqual = (prevProps: StatusCellProps, nextProps: StatusCellProps) =>
  prevProps.value === nextProps.value;

export const StatusCellMemoized = memo(StatusCell, areEqual);
